<script setup>
import { ref } from "vue"
import VueDatePicker from "@vuepic/vue-datepicker"
import "@vuepic/vue-datepicker/dist/main.css"

defineOptions({ inheritAttrs: false })

const props = defineProps({
  modelValue: {
    type: [String, Date, Array, Number],
    default: null
  }
})

const emit = defineEmits(["update:modelValue"])

function extraerAnio(valor) {
  if (!valor) return new Date().getFullYear()
  const anio = parseInt(String(valor).slice(0, 4), 10)
  return Number.isNaN(anio) ? new Date().getFullYear() : anio
}

const picker = ref(null)
// año que el calendario está mostrando actualmente (no necesariamente el
// seleccionado): se actualiza con cada navegación de mes/año
const anioMostrado = ref(extraerAnio(props.modelValue))
const anioAlAbrirSelector = ref(null)

function onUpdateMonthYear({ year }) {
  anioMostrado.value = year
}

function onOverlayToggle({ open, overlay }) {
  if (overlay !== "year") return

  if (open) {
    anioAlAbrirSelector.value = anioMostrado.value
    return
  }

  // el selector de años se cerró: si el año mostrado cambió, no saltamos
  // directo al calendario de días, sino que exigimos elegir también el mes
  if (anioMostrado.value !== anioAlAbrirSelector.value) {
    picker.value?.switchView("month")
  }
}
</script>

<template>
  <VueDatePicker
    ref="picker"
    :model-value="modelValue"
    v-bind="$attrs"
    @update:model-value="emit('update:modelValue', $event)"
    @update-month-year="onUpdateMonthYear"
    @overlay-toggle="onOverlayToggle"
  />
</template>
